/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import { Grid } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormNumberField from "components/FormNumberField";
import SwitchField from "components/SwitchField";
import FormField from "components/FormField";
const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

function Table9({ formData, setFieldValue }) {
  const { formField9, values, errors, touched } = formData;
  const { endowTNDN, endowKHCN, addressEndow, confirmEndow, dateConfirmEndow } = formField9;

  const [data, setData] = useState({
    muc1: [
      {
        id: {
          value: uuidV4(),
          bg: false,
        },
        value2: {
          value: "Doanh thu từ hoạt động chuyển giao công nghệ được giảm",
          bg: false,
        },
        value3: {
          value: "[10]",
          bg: false,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
      {
        id: {
          value: uuidV4(),
          bg: false,
        },
        value2: {
          value: "Chi phí từ hoạt động chuyển giao công nghệ được giảm",
          bg: false,
        },
        value3: {
          value: "[11]",
          bg: false,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
      {
        id: {
          value: uuidV4(),
          bg: false,
        },
        value2: {
          value: "Thu nhập tính thuế TNDN",
          bg: false,
        },
        value3: {
          value: "[12]",
          bg: false,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
      {
        id: {
          value: uuidV4(),
          bg: true,
        },
        value2: {
          value: "Tỷ lệ giảm thuế",
          bg: true,
        },
        value3: {
          value: "[13]",
          bg: true,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
      {
        id: {
          value: uuidV4(),
          bg: false,
        },
        value2: {
          value: "Số thuế TNDN được giảm",
          bg: false,
        },
        value3: {
          value: "[14]",
          bg: false,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
    ],
    muc2: [
      {
        id: uuidV4(),
        value2: {
          value: "",
          bg: true,
        },
      },
      {
        id: uuidV4(),
        value2: {
          value: "",
          bg: true,
        },
      },
      {
        id: uuidV4(),
        value2: {
          value: "",
          bg: true,
        },
      },
      {
        id: uuidV4(),
        value2: {
          value: "",
          bg: true,
        },
      },
      {
        id: uuidV4(),
        value2: {
          value: "",
          bg: true,
        },
      },
    ],
    muc3: [
      {
        id: {
          value: uuidV4(),
          bg: false,
        },
        value2: {
          value:
            "Doanh thu từ việc sản xuất, kinh doanh các sản phẩm hình hành từ kết quả khoa học",
          bg: false,
        },
        value3: {
          value: "[15]",
          bg: false,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
      {
        id: {
          value: uuidV4(),
          bg: false,
        },
        value2: {
          value: "Tổng doanh thu của doanh nghiệp",
          bg: false,
        },
        value3: {
          value: "[16]",
          bg: false,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
      {
        id: {
          value: uuidV4(),
          bg: false,
        },
        value2: {
          value: "Tỷ lệ về doanh thu làm căn cứ xét ưu đãi thuế",
          bg: false,
        },
        value3: {
          value: "[17]",
          bg: false,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
      {
        id: {
          value: uuidV4(),
          bg: false,
        },
        value2: {
          value: "Năm bắt đầu có thu nhập chịu thuế",
          bg: false,
        },
        value3: {
          value: "[18]",
          bg: false,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
    ],
    muc4: [
      {
        id: uuidV4(),
        value2: {
          value: "",
          bg: false,
        },
        value3: {
          value: "",
          bg: false,
        },
        value4: {
          value: "",
          bg: true,
        },
        value5: {
          value: 0,
          bg: false,
        },
        value6: {
          value: "",
          bg: false,
        },
        value7: {
          value: 0,
          bg: false,
        },
        value8: {
          value: 0,
          bg: false,
        },
        value9: {
          value: 0,
          bg: false,
        },
        value10: {
          value: 0,
          bg: false,
        },
        value11: {
          value: 0,
          bg: false,
        },
        value12: {
          value: 0,
          bg: false,
        },
        value13: {
          value: "",
          bg: false,
        },
        value14: {
          value: 0,
          bg: true,
        },
        value15: {
          value: 0,
          bg: true,
        },
        value16: {
          value: 0,
          bg: true,
        },
      },
    ],
    muc5: [
      {
        id: {
          value: uuidV4(),
          bg: true,
        },
        value2: {
          value: "Thuế TNDN phải nộp của hoạt động được hưởng ưu đãi thuế TNDN ([21]=[15]-[16])",
          bg: true,
        },
        value3: {
          value: "[21]",
          bg: true,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
      {
        id: {
          value: uuidV4(),
          bg: false,
        },
        value2: {
          value: "Thuế TNDN nộp thừa kỳ trước chuyển sang kỳ này",
          bg: false,
        },
        value3: {
          value: "[22]",
          bg: false,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
      {
        id: {
          value: uuidV4(),
          bg: false,
        },
        value2: {
          value: "Thuế TNDN đã tạm nộp trong năm",
          bg: false,
        },
        value3: {
          value: "[23]",
          bg: false,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
      {
        id: {
          value: uuidV4(),
          bg: true,
        },
        value2: {
          value:
            "Chênh lệch giữa số thuế phải nộp và số thuế đã tạm nộp trong năm ([24]=[21]-[23])",
          bg: true,
        },
        value3: {
          value: "[24]",
          bg: true,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
      {
        id: {
          value: uuidV4(),
          bg: true,
        },
        value2: {
          value: "Thuế TNDN còn phải nộp ([25]=[21]-[22]-[23]",
          bg: true,
        },
        value3: {
          value: "[24]",
          bg: true,
        },
        value4: {
          value: 0,
          bg: true,
        },
      },
    ],
  });

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      }),
    }));
  };

  const handleAdd = (type) => {
    if (type === "muc4") {
      const newRow = {
        id: uuidV4(),
        value2: {
          value: "",
          bg: false,
        },
        value3: {
          value: "",
          bg: false,
        },
        value4: {
          value: "",
          bg: true,
        },
        value5: {
          value: 0,
          bg: false,
        },
        value6: {
          value: "",
          bg: false,
        },
        value7: {
          value: 0,
          bg: false,
        },
        value8: {
          value: 0,
          bg: false,
        },
        value9: {
          value: 0,
          bg: false,
        },
        value10: {
          value: 0,
          bg: false,
        },
        value11: {
          value: 0,
          bg: false,
        },
        value12: {
          value: 0,
          bg: false,
        },
        value13: {
          value: "",
          bg: false,
        },
        value14: {
          value: 0,
          bg: true,
        },
        value15: {
          value: 0,
          bg: true,
        },
        value16: {
          value: 0,
          bg: true,
        },
      };
      setData((prev) => ({ ...prev, [type]: [...prev[type], newRow] }));
    }
    if (type === "muc2") {
      const newRow = {
        id: uuidV4(),
        value2: {
          value: "",
          bg: true,
        },
      };
      setData((prev) => ({ ...prev, [type]: [...prev[type], newRow] }));
    }
  };

  const handleDelete = (type, id) => {
    setData((prev) => ({ ...prev, [type]: prev[type].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" flexDirection="column" mt={5}>
        <Typography variant="h4" textTransform="uppercase">
          A. Xác định điều kiện và mức độ ưu đãi thuế
        </Typography>
        <Box>
        <Grid container>
        <Grid item sx={12}>
          <SwitchField name={endowTNDN.name} label={endowTNDN.label} value={values.endowTNDN} />
        </Grid>
        </Grid>
        </Box>
        <Box>
          <table style={tableStyle}>
            <thead style={{ background: "#eaeae9" }}>
              <tr>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>STT</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tên chỉ tiêu</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã chỉ tiêu</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số tiền</Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>(1)</Th>
                <Th style={{ textAlign: "center" }}>(2)</Th>
                <Th style={{ textAlign: "center" }}>(3)</Th>
                <Th style={{ textAlign: "center" }}>(4)</Th>
              </tr>
            </thead>
            <tbody>
              {data.muc1.map((item, index) => (
                <tr key={index} style={{}}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: item.id.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {index + 1}
                  </Td>
                  <Td
                    style={{
                      textAlign: "left",
                      background: item.value2.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.value2.value}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      background: item.value3.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.value3.value}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      background: item.value4.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.value4.bg ? (
                      item.value4.value
                    ) : (
                      <InputTable
                        id={item.id}
                        name="value4"
                        value={item.value4.value}
                        onChange={handleChange}
                        rowType="muc1"
                        type="number"
                      />
                    )}
                  </Td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>

        <Grid spacing={3} container mt={5}>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={endowKHCN.name} label={endowKHCN.label} value={values.endowKHCN} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={confirmEndow.name}
            label={confirmEndow.label}
            value={values.confirmEndow}
            error={errors.confirmEndow && touched.confirmEndow}
            success={values.confirmEndow?.toString().length > 0 && !errors.confirmEndow}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            name={dateConfirmEndow.name}
            label={dateConfirmEndow.label}
            error={errors.dateConfirmEndow && touched.dateConfirmEndow}
            success={values.dateConfirmEndow?.toString().length > 0 && !errors.dateConfirmEndow}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={addressEndow.name}
            label={addressEndow.label}
            value={values.addressEndow}
            error={errors.addressEndow && touched.addressEndow}
            success={values.addressEndow?.toString().length > 0 && !errors.addressEndow}
          />
        </Grid>
        </Grid>
      </Box>
      <Box mt={5}>
        <Typography component="label" variant="caption" fontWeight="bold">
          Danh mục công nghệ, sản phẩm do doanh nghiệp sản xuất đủ điều kiện được hưởng ưu đãi
        </Typography>
        <table style={tableStyle}>
          <tbody>
            {data.muc2.map((item, index) => (
              <tr key={index}>
                <Td className="toggle-button" style={{ textAlign: "center", width: "70px" }}>
                  {index + 1}
                  {index === 0 ? (
                    <div className="button-action">
                      <button type="button" onClick={() => handleAdd("muc2")}>
                        Thêm dòng
                      </button>
                    </div>
                  ) : (
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete("muc2", item.id)}>
                        Xóa dòng
                      </button>
                    </div>
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    background: item.value2.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value2.bg ? (
                    item.value2.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value2"
                      value={item.value2.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="text"
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <Box display="flex" flexDirection="column" mt={5}>
        <Typography component="label" variant="caption" fontWeight="bold">
          2. Xác định điều kiện vè doanh thu để được hưởng ưu đãi
        </Typography>
        <Box>
          <table style={tableStyle}>
            <thead style={{ background: "#eaeae9" }}>
              <tr>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>STT</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tên chỉ tiêu</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã chỉ tiêu</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số tiền</Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>(1)</Th>
                <Th style={{ textAlign: "center" }}>(2)</Th>
                <Th style={{ textAlign: "center" }}>(3)</Th>
                <Th style={{ textAlign: "center" }}>(4)</Th>
              </tr>
            </thead>
            <tbody>
              {data.muc3.map((item, index) => (
                <tr key={index} style={{}}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: item.id.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {index + 1}
                  </Td>
                  <Td
                    style={{
                      textAlign: "left",
                      background: item.value2.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.value2.value}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      background: item.value3.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.value3.value}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      background: item.value4.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.value4.bg ? (
                      item.value4.value
                    ) : (
                      <InputTable
                        id={item.id}
                        name="value4"
                        value={item.value4.value}
                        onChange={handleChange}
                        rowType="muc3"
                        type="number"
                      />
                    )}
                  </Td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </Box>
      <Box mt={5}>
        <Typography variant="h4" textTransform="uppercase">
          B. Xác định ưu đãi thuế thu nhập doanh nghiệp của người nộp thuế tại trụ sở chính, đơn vị
          phụ thuộc/ địa điểm kinh doanh khác tỉnh
        </Typography>
        <table style={tableStyle}>
          <tbody>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                TT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Tên NNT, đơn vị phụ thuộc, địa điểm kinh doanh
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Mã số thuế NNT, đơn vị phụ thuôc, mã địa điểm kinh doanh
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Cơ quan thuế quản lý NNT, đơn vị phụ thuộc, địa điểm kinh doanh
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                Xác định thời gian ưu đãi
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="4">
                Kết quả kinh doanh của hoạt động được hưỡng ưu đãi
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="2">
                Xác định thuế TNDN phải nộp
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan="3">
                Xác định số thuế được miễn, giảm
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                Tổng số thuế được ưu đãi
              </Th>
            </tr>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="1">
                Cơ quan Thuế quản lý
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="1">
                Số năm
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="1">
                Từ năm
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="1">
                Doanh thu tính thuế
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="1">
                Chi phí tính thuế
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="1">
                Thu nhập miễn thuế
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="1">
                Chuyển lỗ và bù trừ lãi, lỗ
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="1">
                TNTT được hưởng ưu đãi
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="1">
                Số thuế TNDN phải nộp theo thuế suất phổ thông
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="1">
                Tỷ lệ giảm thuế
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="1">
                Số thuế được miễn
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="1">
                Số thuế được giảm
              </Th>
            </tr>

            <tr style={{ background: "#eaeae9" }}>
              <Th className="toggle-button" style={{ textAlign: "center" }}>
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc4")}>
                    Thêm dòng
                  </button>
                </div>
                (1)
              </Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
              <Th style={{ textAlign: "center" }}>(8)</Th>
              <Th style={{ textAlign: "center" }}>(9)</Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }}>(11)</Th>
              <Th style={{ textAlign: "center" }}>(12)</Th>
              <Th style={{ textAlign: "center" }}>(13)</Th>
              <Th style={{ textAlign: "center" }}>(14)</Th>
              <Th style={{ textAlign: "center" }}>(15)</Th>
              <Th style={{ textAlign: "center" }}>(16=14+15)</Th>
            </tr>
            {data.muc4.map((item, index) => (
              <tr key={index}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc4", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    background: item.value2.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value2.bg ? (
                    item.value2.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value2"
                      value={item.value2.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="text"
                    />
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    background: item.value3.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value3.bg ? (
                    item.value3.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value3"
                      value={item.value3.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="text"
                    />
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    background: item.value4.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value4.bg ? (
                    item.value4.value
                  ) : (
                    <select
                      style={selectStyle}
                      onChange={(e) =>
                        handleChange({
                          name: "value4",
                          value: e.target.value,
                          id: item.id,
                          rowType: "muc4",
                        })
                      }
                    >
                      <option value="">--</option>
                      <option value="value1">Value1</option>
                      <option value="value2">Value2</option>
                    </select>
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: item.value5.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value5.bg ? (
                    item.value5.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value5"
                      value={item.value5.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="number"
                    />
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: item.value5.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value6.bg ? (
                    item.value6.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value6"
                      value={item.value6.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="number"
                    />
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: item.value7.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value7.bg ? (
                    item.value7.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value7"
                      value={item.value7.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="number"
                    />
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: item.value8.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value8.bg ? (
                    item.value8.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value8"
                      value={item.value8.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="number"
                    />
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: item.value9.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value9.bg ? (
                    item.value9.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value9"
                      value={item.value9.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="number"
                    />
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: item.value10.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value10.bg ? (
                    item.value10.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value10"
                      value={item.value10.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="number"
                    />
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: item.value11.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value11.bg ? (
                    item.value11.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value11"
                      value={item.value11.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="number"
                    />
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: item.value12.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value12.bg ? (
                    item.value12.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value12"
                      value={item.value12.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="number"
                    />
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    background: item.value13.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value13.bg ? (
                    item.value13.value
                  ) : (
                    <select
                      style={selectStyle}
                      onChange={(e) =>
                        handleChange({
                          name: "value13",
                          value: e.target.value,
                          id: item.id,
                          rowType: "muc4",
                        })
                      }
                    >
                      <option value="">--</option>
                      <option value="value1">Value1</option>
                      <option value="value2">Value2</option>
                    </select>
                  )}
                </Td>

                <Td
                  style={{
                    textAlign: "right",
                    background: item.value14.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value14.bg ? (
                    item.value14.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value14"
                      value={item.value14.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="number"
                    />
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: item.value15.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value15.bg ? (
                    item.value15.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value15"
                      value={item.value15.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="number"
                    />
                  )}
                </Td>
                <Td
                  style={{
                    textAlign: "right",
                    background: item.value16.bg ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.value16.bg ? (
                    item.value16.value
                  ) : (
                    <InputTable
                      id={item.id}
                      name="value16"
                      value={item.value16.value}
                      onChange={handleChange}
                      rowType="muc4"
                      type="number"
                    />
                  )}
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}
                colSpan="4"
              >
                Tổng cộng
              </Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>0</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}></Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>0</Td>
              <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold" }}>0</Td>
            </tr>
          </tbody>
        </table>
      </Box>
      <Box display="flex" flexDirection="column" mt={5}>
        <Typography variant="h4" textTransform="uppercase">
          C. Xác định số thuế TNDN phải nộp của hoạt động được hưởng ưu đãi thuế TNDN của đơn vị phụ
          thuộc/ địa điểm kinh doanh khác tỉnh
        </Typography>
        <Box>
          <table style={tableStyle}>
            <thead style={{ background: "#eaeae9" }}>
              <tr>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>STT</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tên chỉ tiêu</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Mã chỉ tiêu</Th>
                <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số tiền</Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>(1)</Th>
                <Th style={{ textAlign: "center" }}>(2)</Th>
                <Th style={{ textAlign: "center" }}>(3)</Th>
                <Th style={{ textAlign: "center" }}>(4)</Th>
              </tr>
            </thead>
            <tbody>
              {data.muc5.map((item, index) => (
                <tr key={index} style={{}}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: item.id.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {index + 1}
                  </Td>
                  <Td
                    style={{
                      textAlign: "left",
                      background: item.value2.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.value2.value}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      background: item.value3.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.value3.value}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      background: item.value4.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.value4.bg ? (
                      item.value4.value
                    ) : (
                      <InputTable
                        id={item.id}
                        name="value4"
                        value={item.value4.value}
                        onChange={handleChange}
                        rowType="muc5"
                        type="number"
                      />
                    )}
                  </Td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </Box>
    </Box>
  );
}

export default memo(Table9);

function InputTable(props) {
  const { onChange, type = "text", name, id, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type, id, rowType });
    } else if (type === "date") {
      onChange({ value, name, type, id, rowType });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type, id, rowType });
    }
  }
  return (
    <input
      name={name}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        width: "100%",
        minWidth: "70px",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
